import { getMonth, getYear } from 'date-fns'


import axios from 'axios'
import miniToastr from 'mini-toastr'
import routerVocational from '../../../router/vocational.js'
import routerFamilial from '../../../router/familial.js'
import routerFinancial from '../../../router/financial.js'
import routerMental from "../../../router/mental.js"
import routerSocial from "../../../router/social.js"
import routerSpiritual from "../../../router/spiritual.js"
import routerPhysical from "../../../router/physical.js"
import routerPersonal from "../../../router/personal.js"


import configAll from '../../../../config/index.cjs'

const config = configAll[process.env.NODE_ENV === 'production' ? 'build' : (process.env.NODE_ENV === 'prodlocal') ? 'prodlocal' : 'dev']


const API_PERSONAL_URL = config.urlServer
const API_FAMILIAL_URL = config.urlServerFamilial
const API_VOCATIONAL_URL = config.urlServerVocational
const API_FINANCIAL_URL = config.urlServerFinancial
const API_SOCIAL_URL = config.urlServerSocial
const API_SPIRITUAL_URL = config.urlServerSpiritual
const API_PHYSICAL_URL = config.urlServerPhysical
const API_MENTAL_URL = config.urlServerMental
const LOGIN_FAMILIAL_URL = `${API_FAMILIAL_URL}api/auth/signin/`
const LOGIN_VOCATIONAL_URL = `${API_VOCATIONAL_URL}api/auth/signin/`
const LOGIN_FINANCIAL_URL = `${API_FINANCIAL_URL}api/auth/signin/`
const LOGIN_SOCIAL_URL = `${API_SOCIAL_URL}api/auth/signin/`
const LOGIN_SPIRITUAL_URL = `${API_SPIRITUAL_URL}api/auth/signin/`
const LOGIN_PHYSICAL_URL = `${API_PHYSICAL_URL}api/auth/signin/`
const LOGIN_MENTAL_URL = `${API_MENTAL_URL}api/auth/signin/`
const LOGIN_PERSONAL_URL = `${API_PERSONAL_URL}api/auth/signin/`
const SIGNUP_URL = `${API_PERSONAL_URL}api/auth/signup/` //@TODO for each app
// const USERS_PERS_URL = `${API_URL}api/personal/users/`
// const USERS_MENTAL_URL = `${API_URL}api/mental/users/`
const USERS_VOCATIONAL_URL = `${API_VOCATIONAL_URL}api/voc/users/`
const USERS_FAMILIAL_URL = `${API_FAMILIAL_URL}api/fam/users/`
const USERS_FINANCIAL_URL = `${API_FINANCIAL_URL}api/fin/users/`
const USERS_PHYSICAL_URL = `${API_PHYSICAL_URL}api/phy/users/`
const USERS_SOCIAL_URL = `${API_SOCIAL_URL}api/soc/users/`
const USERS_SPIRITUAL_URL = `${API_SPIRITUAL_URL}api/spi/users/`
const USERS_MENTAL_URL = `${API_MENTAL_URL}api/men/users/`
const USERS_PERSONAL_URL = `${API_PERSONAL_URL}api/per/users/`

export default {
  namespaced: true,
  state: {
    idToken: localStorage.getItem('token') || null,
    userId: localStorage.getItem('userId') || null,
    ppa: localStorage.getItem('ppa') || null,
    user: null,
    status: ''
  },
  mutations: {
    auth_request (state) {
      // eslint-disable-next-line
      state.status = 'loading';
    },
    authUser (state, userData) {
      // eslint-disable-next-line
      state.idToken = userData.token;
      // eslint-disable-next-line
      state.userId = userData.userId;
      // eslint-disable-next-line
      state.status = 'success';

      // eslint-disable-next-line
      state.ppa = userData.ppa;
    },
    storeUser (state, user) {
      // eslint-disable-next-line
      state.user = user;
    },
    clearAuthData (state) {
      // eslint-disable-next-line
      state.idToken = null;
      // eslint-disable-next-line
      state.userId = null;
      // eslint-disable-next-line
      state.status = 'error';
      // eslint-disable-next-line
      state.ppa = null;
    },
    logout (state) {
      // eslint-disable-next-line
      state.idToken = null;
      // eslint-disable-next-line
      state.userId = null;
      // eslint-disable-next-line
      state.status = '';
      // eslint-disable-next-line
      state.ppa = null;
    }
  },
  actions: {
    setLogoutTimer ({ commit }, expirationTime) {
      setTimeout(() => {
        commit('clearAuthData')
      }, expirationTime * 1000000)
    },
    signup (context, authData) {
      axios.post(SIGNUP_URL, authData)
        .then(() => {
          miniToastr.success('Signup completed, but account must be activated by admin!', '', 1500)
        })
        .catch((error) => {
          miniToastr.error(error.response.data.errorMessage, 'Signup failed!', 1500)
        })
    },
    login ({ commit, dispatch }, authData) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        let loginUrl = ''
        if (authData.credentials.db == 'fam') {
          loginUrl = LOGIN_FAMILIAL_URL
        }else if (authData.credentials.db == 'voc') {
          loginUrl = LOGIN_VOCATIONAL_URL
        } else if (authData.credentials.db == 'fin') {
          loginUrl = LOGIN_FINANCIAL_URL
        } else if (authData.credentials.db == 'soc') {
          loginUrl = LOGIN_SOCIAL_URL
        } else if (authData.credentials.db == 'spi') {
          loginUrl = LOGIN_SPIRITUAL_URL
        } else if (authData.credentials.db == 'men') {
          loginUrl = LOGIN_MENTAL_URL
        } else if (authData.credentials.db == 'phy') {
          loginUrl = LOGIN_PHYSICAL_URL
        } else if (authData.credentials.db == 'per') {
          loginUrl = LOGIN_PERSONAL_URL
        }
        axios.post(loginUrl, authData.credentials)
          .then((resp) => {
            const now = new Date()
            const expirationDate = new Date(now.getTime() + (resp.data.expiresIn * 1000))
            localStorage.setItem('token', resp.data.idToken)
            localStorage.setItem('userId', resp.data.localId)
            localStorage.setItem('ppa', authData.credentials.db)
            localStorage.setItem('expirationDate', expirationDate)
            // Add the following line:
            // eslint-disable-next-line
            axios.defaults.headers.common['Authorization'] = resp.data.idToken;
            commit('authUser', {
              token: resp.data.idToken,
              userId: resp.data.localId,
              ppa: authData.credentials.db
            })
            dispatch('setLogoutTimer', resp.data.expiresIn)

            miniToastr.success('Login successfull!', '', 1500)
            resolve(resp)
          })
          .catch((err) => {
            commit('clearAuthData')
            // console.log(err)
            miniToastr.error(err.response.data.errorMessage, 'Login failed!', 1500)
            localStorage.removeItem('token')
            localStorage.removeItem('userId')
            localStorage.removeItem('expirationDate')
            localStorage.removeItem('ppa')
            reject(err)
          })
      })
    },
    tryAutoLogin ({ commit }) {
      const userId = localStorage.getItem('userId')
      const ppa = localStorage.getItem('ppa')
      const currenturl = window.location.pathname;
      if (!currenturl.includes(ppa)) {
        commit('logout')
      } else {
        const token = localStorage.getItem('token')
        if (!token) {
          return
        }
        const expirationDate = localStorage.getItem('expirationDate')
        const now = new Date()
        if (now >= expirationDate) {
          return
        }
        commit('authUser', {
          token,
          userId,
          ppa
        })
        let month = getMonth(new Date()) + 1;
        if (month < 10) {
          month = `0${month}`
        }
        const year = getYear(new Date())
        let route;


        if (ppa === 'men') {
          route = '/articles'
          routerMental.push(route)
        } else if (ppa == 'voc') {
          route = `/list`
          routerVocational.push(route)
        } else if (ppa == 'fam') {
          route = `/list`
          routerFamilial.push(route)
        } else if (ppa == 'fin') {
          route = `/list`
          routerFinancial.push(route)
        } else if (ppa == 'phy') {
          route = `/list`
          routerPhysical.push(route)
        } else if (ppa == 'soc') {
          route = `/list`
          routerSocial.push(route)
        } else if (ppa == 'spi') {
          route = `/list`
          routerSpiritual.push(route)
        } else {
          route = `/month/${month}/${year}`
          routerPersonal.push(route)
        }
      }

    },
    logout ({ commit }) {
      return new Promise((resolve) => {
        const ppa = localStorage.getItem('ppa')
        commit('logout')
        localStorage.removeItem('expirationDate')
        localStorage.removeItem('token')
        localStorage.removeItem('userId')
        localStorage.removeItem('ppa')
        // eslint-disable-next-line
        delete axios.defaults.headers.common['Authorization'];

        let route = '/'
        if (ppa === 'men') {
          routerMental.push(route)
        } else if (ppa == 'voc') {
          routerVocational.push(route)
        } else if (ppa == 'fam') {
          routerFamilial.push(route)
        } else if (ppa == 'fin') {
          routerFinancial.push(route)
        } else if (ppa == 'phy') {
          routerPhysical.push(route)
        } else if (ppa == 'soc') {
          routerSocial.push(route)
        } else if (ppa == 'spi') {
          routerSpiritual.push(route)
        } else {
          routerPersonal.push(route)
        }

        resolve()
      })
    },
    fetchUser ({ commit, state }) {
      if (!state.idToken || !state.userId) {
        return
      }
      let userUrl
      if (state.ppa === 'men') {
        userUrl = USERS_MENTAL_URL
      } else if (state.ppa === 'voc') {
        userUrl = USERS_VOCATIONAL_URL
      } else if (state.ppa == 'fam') {
        userUrl = USERS_FAMILIAL_URL
      } else if (state.ppa == 'fin') {
        userUrl = USERS_FINANCIAL_URL
      } else if (state.ppa == 'phy') {
        userUrl = USERS_PHYSICAL_URL
      } else if (state.ppa == 'soc') {
        userUrl = USERS_SOCIAL_URL
      } else if (state.ppa == 'spi') {
        userUrl = USERS_SPIRITUAL_URL
      } else {
        userUrl = USERS_PERSONAL_URL
      }
      axios.get(`${userUrl}${state.userId}`)
        .then((data) => {
          commit('storeUser', data.data)
        })
        .catch((err) => {
          // console.log(err)
          miniToastr.error(err.response.data.errorMessage, 'Logged user cannot be fetched', 1500)
        })
    }
  },
  getters: {
    user (state) {
      return state.user
    },
    isAuthenticated (state) {
      return state.idToken !== null
    },
    token (state) {
      return state.idToken
    },
    ppa (state) {
      return state.ppa
    },
    authStatus: state => state.status
  }
}
